module.exports = __webpack_public_path__ + "img/lenovo.6e501ba3.svg";